module.exports = __webpack_public_path__ + "static/media/nfa.ba69f805.jpg";